import isEqual from 'lodash/isEqual'
import { useCallback, useEffect, useState, useSyncExternalStore } from 'react'
import { isElectron } from '~/utils/common'

import { SharedVariables } from '@mangovoice/types'

// const subscribe = (
//   variableName: keyof typeof SharedVariables,
//   callback: () => void,
// ) => window.electron?.sharedVariables?.subscribe(variableName, callback)
//
// const getSnapshot = <T>(variableName: keyof typeof SharedVariables): T =>
//   window.electron?.sharedVariables?.getValue(variableName) as T
//
// export function useSharedVariable<T>(
//   variableName: keyof typeof SharedVariables,
// ) {
//   const subscribeCallback = useCallback(
//     (callback: () => void) => {
//       const cleanup = subscribe(variableName, callback)
//       return cleanup ?? (() => {}) // Return an empty function if cleanup is undefined
//     },
//     [variableName],
//   )
//
//   const updateValue = useCallback(
//     (callback) => subscribe(variableName, callback),
//     [variableName],
//   )
//
//   // Use useSyncExternalStore to subscribe to the external store
//   const value = useSyncExternalStore<T>(subscribeCallback, () =>
//     getSnapshot<T>(variableName),
//   )
//
//   return [value, updateValue] as const
// }

export function useSharedVariable<T>(
  variableName: keyof typeof SharedVariables,
  defaultValue?: T | null,
) {
  const [value, setValue] = useState<T | null>(null)

  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      const cleanup = window.electron?.sharedVariables?.subscribe(
        variableName,
        (newValue: T) => {
          if (!isEqual(value, newValue)) {
            setValue(newValue)
            onStoreChange()
          }
        },
      )

      return () => {
        cleanup?.()
      }
    },
    [variableName, value],
  )

  const getSnapshot = useCallback(() => value, [value])

  const updateValue = useCallback(
    (newValue: T) => {
      window.electron?.sharedVariables?.setValue(variableName, newValue)
    },
    [variableName],
  )

  useEffect(() => {
    let isMounted = true

    window.electron?.sharedVariables
      ?.getValue(variableName)
      .then((initialValue: T) => {
        if (isMounted) {
          setValue(initialValue)
        }
      })
      .catch((error: any) => {
        console.error('Error fetching initial value for', variableName, error)
      })

    return () => {
      isMounted = false
    }
  }, [variableName])

  // Use useSyncExternalStore to subscribe to the external store
  useSyncExternalStore(subscribe, getSnapshot)

  if (!isElectron) {
    return [defaultValue as T, (_: T) => {}] as const
  } else {
    return [value, updateValue] as const
  }
}
